module.exports = __webpack_public_path__ + "img/date.e0ba707c.png";